import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography, Container, IconButton, Stack } from '@mui/material';
import Barcode from 'react-barcode';
import Countdown from 'react-countdown';
import QRCode from 'react-qr-code';
import ClockIcon from '../../../components/icons/ClockIcon';
import AppButton from '../../../components/ui/AppButton';
import { CouponStatus } from '../../../constants/coupon';

const CouponQRTab = ({ code, data, isPending, onClose, onConfirm }) => {
  // 30 minutes countdown (matching Step 1's warning)
  const countdownDate = Date.now() + 30 * 60 * 1000;

  return (
    <Container maxWidth="md" sx={{ py: { xs: 2, sm: 4, md: 8 }, pb: { xs: 12, sm: 16, md: 20 } }}>
      <Box
        sx={{
          background: 'white',
          borderRadius: '24px',
          p: 3,
          position: 'relative',
          textAlign: 'center',
          boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 16,
            right: 16,
            color: 'black',
          }}
        >
          <CloseIcon sx={{ fontSize: '2rem' }} />
        </IconButton>

        {/* Timer Section */}
        <Stack direction="row" alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
          <Box
            sx={{
              width: 50,
              height: 50,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <ClockIcon />
          </Box>
          <Countdown date={countdownDate} renderer={CountdownRenderer} />
        </Stack>

        {/* Barcode Section */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              p: 2,
              background: 'white',
            }}
          >
            <Barcode
              value={code || '1234567890'}
              format="CODE128"
              width={2}
              height={80}
              displayValue={false}
            />
          </Box>
        </Box>

        {/* QR Code Section */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <Box
            sx={{
              p: 2,
              background: 'white',
            }}
          >
            <QRCode value={code || '1234567890'} size={200} />
          </Box>
        </Box>

        {/* Dashed Divider */}
        <Box
          sx={{
            width: '80%',
            borderTop: '2px dashed #ccc',
            my: 2,
            mx: 'auto',
          }}
        />

        {/* Footer Text */}
        <Typography
          sx={{
            color: '#FF0000',
            fontSize: '1.75rem',
            fontWeight: '600',
            mb: 3,
          }}
        >
          สำหรับพนักงาน ณ จุดขายเท่านั้น
        </Typography>

        {/* Confirm Button */}
        {data?.status.toLowerCase() !== CouponStatus.WAITING && !isPending && (
          <AppButton
            variant="dangerStrong"
            onClick={onConfirm}
            sx={{
              borderRadius: '40px',
              py: 1.25,
              px: 4,
              fontSize: '1.5rem',
              fontWeight: '600',
              minWidth: 280,
            }}
          >
            ยืนยันว่าใช้คูปองนี้แล้ว
          </AppButton>
        )}
        {data?.status.toLowerCase() === CouponStatus.WAITING && (
          <Typography
            sx={{
              color: '#FF0000',
              fontSize: '1.75rem',
              fontWeight: 600,
              mb: 1,
              textAlign: 'center',
              textDecoration: 'underline',
            }}
          >
            คูปองนี้ถูกเปิดใช้งานแล้ว
          </Typography>
        )}
      </Box>
    </Container>
  );
};

const CountdownRenderer = ({ minutes, seconds }) => {
  return (
    <Typography
      sx={{
        fontSize: '2.5rem',
        fontWeight: 'bold',
        color: '#FF0000',
        ml: 1,
        lineHeight: 1,
      }}
    >
      {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
    </Typography>
  );
};

export default CouponQRTab;
